import { toNumberOrZero } from '~/utils/functions';
import { Produto } from '../../protocols';
import { calculaReducaoBaseCalculo } from './ReducaoBaseCalculo';
import { calculaImpostosIbsCbs } from '~/components/NovosInputs/InputIbsCbs/functions/calculaImpostosIbsCbs';

interface CalculaTotaisResponse {
  totalNF: number;
  totalBC: number;
  totalICMS: number;
  totBcIbsCbs: number;
  totCbs: number;
  totIbsEst: number;
  totIbsMun: number;
}

export function CalculaTotais(
  itens: Produto[],
  flg_orgao_publico: boolean,
  flg_calcula_st: boolean,
  TipoRegime: number,
): CalculaTotaisResponse {
  let vDebito_ICMS = 0;
  let vBC_ICMS = 0;
  let vTotal_Nota_Fiscal = 0;
  let vTotBcIbsCbs = 0;
  let vTotCbs = 0;
  let vTotIbsEst = 0;
  let vTotIbsMun = 0;

  const teste = [];
  for (let i = 0; i < itens.length; i++) {
    teste.push({
      cod_produto: itens[i].cod_produto,
      flg_orgao_publico,
      flg_ignora_icms_nf_cli: itens[i].flg_ignora_icms_nf_cli,
      tipo_tributacao: itens[i].tipo_tributacao,
      TipoRegime,
      flg_calcula_st,
      flg_prod_propria: itens[i].flg_prod_propria,
      val_reducao: itens[i].val_reducao,
    });
    vTotal_Nota_Fiscal += parseFloat(
      (itens[i].val_tabela_liq + itens[i].val_ipi).toFixed(2),
    );

    if (flg_orgao_publico) {
      vDebito_ICMS += itens[i].val_desconto * itens[i].qtd_entrada;
      vBC_ICMS = 0.0;
      vDebito_ICMS = 0.0;
    } else {
      // Débito ICMS
      if (itens[i].flg_ignora_icms_nf_cli !== true) {
        // Base Cálculo ICMS
        switch (itens[i].tipo_tributacao) {
          case 0:
          case 4:
            vBC_ICMS += itens[i].val_tabela_liq;
            break;
          case 2:
            vBC_ICMS += calculaReducaoBaseCalculo(
              itens[i].val_tabela_liq,
              itens[i].val_reducao,
            );
            break;
          default:
            break;
        }
        vDebito_ICMS += itens[i].val_icms;
      }

      if (
        TipoRegime !== 2 &&
        (flg_calcula_st || itens[i].flg_prod_propria) &&
        itens[i].tipo_tributacao === 3
      ) {
        // Débito ICMS
        if (itens[i].flg_ignora_icms_nf_cli !== true) {
          if (itens[i].val_reducao > 0.0) {
            vBC_ICMS += calculaReducaoBaseCalculo(
              itens[i].val_tabela_liq,
              itens[i].val_reducao,
            );
          } else {
            vBC_ICMS += itens[i].val_tabela_liq;
          }

          vDebito_ICMS += itens[i].val_icms;
        }
      }
    }

    const { val_bc_ibs_cbs, val_cbs, val_ibs_est, val_ibs_mun } =
      calculaImpostosIbsCbs(
        {
          per_aliq_cbs: toNumberOrZero(itens[i].per_aliq_cbs),
          per_aliq_ibs_est: toNumberOrZero(itens[i].per_aliq_ibs_est),
          per_aliq_ibs_mun: toNumberOrZero(itens[i].per_aliq_ibs_mun),
          per_red_cbs: toNumberOrZero(itens[i].per_red_cbs),
          per_red_ibs: toNumberOrZero(itens[i].per_red_ibs),
          val_red_social: toNumberOrZero(itens[i].val_red_social),
        },
        toNumberOrZero(itens[i].val_tabela_liq),
        toNumberOrZero(itens[i].val_icms) +
          toNumberOrZero(itens[i].val_fcp_icms),
        toNumberOrZero(itens[i].val_pis) + toNumberOrZero(itens[i].val_cofins),
        toNumberOrZero(itens[i].cod_ibs_cbs),
      );

    vTotBcIbsCbs += val_bc_ibs_cbs;
    vTotCbs += val_cbs;
    vTotIbsEst += val_ibs_est;
    vTotIbsMun += val_ibs_mun;
  }

  return {
    totalNF: vTotal_Nota_Fiscal,
    totalBC: vBC_ICMS,
    totalICMS: vDebito_ICMS,
    totBcIbsCbs: vTotBcIbsCbs,
    totCbs: vTotCbs,
    totIbsEst: vTotIbsEst,
    totIbsMun: vTotIbsMun,
  };
}
